// Set axios defaults to use for each request
import axios from 'axios';
axios.defaults.baseURL = indexJSVars.ajaxurl;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

//Libraries
import './libs/gsap.min';
import './libs/gaspScrollTrigger.min';
// Animations
import './animations/fadeInOnScroll';
import './animations/smoothScroll';
import './animations/slidingText';
import './animations/parralaxImages';
import './animations/lockDiv';

//Functions
import './functions/utilities';
// import './functions/headerScroll';
import './functions/mailchimp';
import './functions/swiper';
import './functions/accordionToggle';
import './functions/navOverlay';
// Import main scss file here. This will compile to a css file in the dist folder
import '../scss/style.scss';
